export const HOST_CLIENT = process.env.REACT_APP_HOST_CLIENT;
export const HOST_PREVIEW =
  process.env.REACT_APP_HOST_CLIENT + "preview-article/";
